import store from 'app/store';
import { FuseLoadable } from '@fuse';
import Split from '../../../../split';

const Index = {
    auth: ['admin', 'sub-admin', 'transport', 'sub-transport', 'processor', 'sub-processor'],
    routes: [
        {
            path: '/old/dropoffs/:date?',
            component: FuseLoadable({
                loader: () => {
                    switch (store.getState().persisted.auth.user.role) {
                        case 'admin':
                        case 'sub-admin':
                            return import('./raw-milk/admin/old/AdminDropoffsApp');
                        case 'transport':
                        case 'sub-transport':
                            return import('./raw-milk/hauling/old/HaulingDropoffsApp');
                        case 'processor':
                        case 'sub-processor':
                            if (store.getState().persisted.auth.user.data.name === 'DFNS') {
                                return import('./raw-milk/processor/old/DFNSDropoffsApp');
                            }
                            return import('./raw-milk/processor/old/ProcessorDropoffsApp');
                        default:
                            break;
                    }
                },
            }),
        },
        {
            path: '/dropoffs/:date?',
            component: FuseLoadable({
                loader: () => {
                    switch (store.getState().persisted.auth.user.role) {
                        case 'admin':
                        case 'sub-admin':
                            if (Split.getBooleanTreatment('can_use_new_route_session_table')) {
                                return import('./raw-milk/admin/AdminDropoffsApp');
                            }
                            return import('./raw-milk/admin/old/AdminDropoffsApp');
                        case 'transport':
                        case 'sub-transport':
                            if (Split.getBooleanTreatment('can_use_new_route_session_table')) {
                                return import('./raw-milk/hauling/HaulingDropoffsApp');
                            }
                            return import('./raw-milk/hauling/old/HaulingDropoffsApp');
                        case 'processor':
                        case 'sub-processor':
                            if (Split.getBooleanTreatment('can_use_new_route_session_table')) {
                                if (store.getState().persisted.auth.user.data.name === 'DFNS') {
                                    return import('./raw-milk/processor/DFNSDropoffsApp');
                                }
                                return import('./raw-milk/processor/ProcessorDropoffsApp');
                            }
                            if (store.getState().persisted.auth.user.data.name === 'DFNS') {
                                return import('./raw-milk/processor/old/DFNSDropoffsApp');
                            }
                            return import('./raw-milk/processor/old/ProcessorDropoffsApp');
                        default:
                            break;
                    }
                },
            }),
        },
        {
            path: '/cream-dropoffs/:date?',
            component: FuseLoadable({
                loader: () => {
                    switch (store.getState().persisted.auth.user.role) {
                        case 'admin':
                        case 'sub-admin':
                            return import('./cream/CreamDropoffsApp');
                        case 'transport':
                        case 'sub-transport':
                            return import('./cream/CreamDropoffsApp');
                        default:
                            break;
                    }
                },
            }),
        },
    ],
};

export default [Index];
